import Component from './serial_code_unassigned_delete.vue'
export default Component
